import { Modal } from 'antd'
import styled from 'styled-components'

export const ModalStyled = styled(Modal)`
  .ant-btn-primary {
    color: red !important;
    background: red !important;
  }
`
